import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// utils

import { EndPoint } from '../../util/EndPoint';
// services

import { BaseService } from '../../util/BaseService';
import { RESTClientService } from '../../util/RESTClientService';
import { MensagemUtil } from '../../util/notificacao/mensagemUtil';
export class ConsultaMedicinaService extends BaseService {
/**
 * @param {?} _restCliente
 * @param {?} mensagemUtil
 */
constructor(private _restCliente: RESTClientService,
private mensagemUtil: MensagemUtil) {
    super(mensagemUtil);
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @param {?} codigoEmpresa
 * @return {?}
 */
public getCombo(codigoInstituicao: number, rgmAluno: number, codigoEmpresa: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaComboTurmaMedicina(codigoInstituicao, rgmAluno, codigoEmpresa))
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public getDisciplinas(codigoInstituicao: number, codigoAluno: number, codigoTurma: number): Observable<any[]> {
    return this._restCliente.get(EndPoint.buscaDisciplinasMedicina(codigoInstituicao, codigoAluno, codigoTurma) )
      .catch(error => this.handleError(error));
  }
/**
 * @param {?} codigoDisciplina
 * @param {?} idOferta
 * @param {?} codigoAluno
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @return {?}
 */
public getSubDisciplinas(codigoDisciplina: number, idOferta: number, codigoAluno: number, codigoInstituicao: number, codigoTurma: number){
    return this._restCliente.get(EndPoint.buscaSubDisciplinasMedicina(codigoDisciplina, idOferta, codigoAluno, codigoInstituicao, codigoTurma))
      .catch(error => this.handleError(error));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: RESTClientService, },
{type: MensagemUtil, },
];
}

function ConsultaMedicinaService_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaMedicinaService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaMedicinaService.ctorParameters;
/** @type {?} */
ConsultaMedicinaService.prototype._restCliente;
/** @type {?} */
ConsultaMedicinaService.prototype.mensagemUtil;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
